var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"d-flex flex-row main"},[_c('div',{attrs:{"id":"nav"}},[_c('NavBar')],1),_c('div',{staticClass:"d-flex flex-row ",attrs:{"id":"content"}},[_c('div',{staticClass:"nav"}),_c('HelloWorld')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }